import { render, staticRenderFns } from "./TeacherSelectionModal.vue?vue&type=template&id=37904759"
import script from "./TeacherSelectionModal.vue?vue&type=script&lang=js"
export * from "./TeacherSelectionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports